/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Pick_Retry_ActionInputs */

const en_onboarding_v1_pick_retry_action = /** @type {(inputs: Onboarding_V1_Pick_Retry_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const de_onboarding_v1_pick_retry_action = /** @type {(inputs: Onboarding_V1_Pick_Retry_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const pt_br2_onboarding_v1_pick_retry_action = /** @type {(inputs: Onboarding_V1_Pick_Retry_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente`)
};

const tr_onboarding_v1_pick_retry_action = /** @type {(inputs: Onboarding_V1_Pick_Retry_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden dene`)
};

const zh_cn2_onboarding_v1_pick_retry_action = /** @type {(inputs: Onboarding_V1_Pick_Retry_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const zh_hk2_onboarding_v1_pick_retry_action = /** @type {(inputs: Onboarding_V1_Pick_Retry_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重試`)
};

const ko_kr2_onboarding_v1_pick_retry_action = /** @type {(inputs: Onboarding_V1_Pick_Retry_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 시도`)
};

const ru_ru2_onboarding_v1_pick_retry_action = /** @type {(inputs: Onboarding_V1_Pick_Retry_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторить`)
};

const es_419_onboarding_v1_pick_retry_action = /** @type {(inputs: Onboarding_V1_Pick_Retry_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Onboarding_V1_Pick_Retry_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_pick_retry_action = /** @type {((inputs?: Onboarding_V1_Pick_Retry_ActionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Pick_Retry_ActionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_pick_retry_action(inputs)
	if (locale === "de") return de_onboarding_v1_pick_retry_action(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_pick_retry_action(inputs)
	if (locale === "tr") return tr_onboarding_v1_pick_retry_action(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_pick_retry_action(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_pick_retry_action(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_pick_retry_action(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_pick_retry_action(inputs)
	return es_419_onboarding_v1_pick_retry_action(inputs)
});